module.exports = __webpack_public_path__ + "img/avatar-2.5eb89229.png";